import { ref, computed } from 'vue'
import { acceptHMRUpdate, defineStore } from 'pinia'
import { CPSupportGateway } from '../gateways/CPSupportGateway'
import type { SupportChat } from '../models/SupportChat'

const useSupportStore = defineStore('shared/support', () => {
  const gateway = CPSupportGateway.instance()

  const data = ref<SupportChat | undefined>()
  const fetched = ref(false)

  const isSupportActive = computed(() => data.value?.isSupportActive ?? false)
  const supportSubdomain = computed(() => data.value?.supportSubdomain)
  const hasSupportSubdomain = computed(() => !!supportSubdomain.value)
  const user = computed(() => data.value?.user)
  const trayWhitelabelSupportUrl = computed(() => data.value?.trayWhitelabelSupportUrl)
  const isCheffContract = computed(() => data.value?.isCheffContract ?? false)
  const chatCode = computed(() => data.value?.chatCode)
  const hasChatSupport = computed(() => isCheffContract.value || hasSupportSubdomain.value)

  async function fetch (): Promise<SupportChat | undefined> {
    if (fetched.value) {
      return data.value
    }

    try {
      const result = await gateway.getSupportChatData()

      if (!result.isError()) {
        data.value = result.getValue()
      }
    } catch {
      // Non-critical
    }

    fetched.value = true
    return data.value
  }

  function $reset (): void {
    data.value = undefined
    fetched.value = false
  }

  return {
    data,
    isSupportActive,
    supportSubdomain,
    hasSupportSubdomain,
    user,
    trayWhitelabelSupportUrl,
    isCheffContract,
    chatCode,
    hasChatSupport,
    fetch,
    $reset
  }
})

export default useSupportStore

/* c8 ignore next 3 */
if ((import.meta as any).hot) {
  (import.meta as any).hot.accept(acceptHMRUpdate(useSupportStore, (import.meta as any).hot))
}
